import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MORTGAGE_CUSTOMER_SERVICE_DISPLAY } from '@ld.consumer-portal/constants';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-terms-and-conditions-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrl: './terms-and-conditions-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionsModalComponent {
  private readonly transloco = inject(TranslocoService);

  protected readonly isVisible = signal(true);

  readonly closeModal = output<void>();

  protected readonly customerServicePhone = MORTGAGE_CUSTOMER_SERVICE_DISPLAY;

  readonly content1 = input<string>(this.transloco.translate('modalsTermsAndConditionsParagraph1'));

  readonly content2 = input<string>(
    this.transloco.translate('modalsTermsAndConditionsParagraph2', { phone: MORTGAGE_CUSTOMER_SERVICE_DISPLAY })
  );

  protected onClose(): void {
    this.close();
  }

  protected onBack(): void {
    this.close();
  }

  private close(): void {
    this.isVisible.set(false);
    setTimeout(() => {
      this.closeModal.emit();
    }, 200);
  }
}
